// src/components/dev/utils/DragNDrop/Styled.ts
import styled from "styled-components";

// Define types for Container props
interface ContainerProps {
  $isDragActive: boolean;
  $isDragAccept: boolean;
  $isDragReject: boolean;
}

export const Container = styled.div<ContainerProps>`
  border: 2px dashed ${(props) =>
    props.$isDragActive ? "#2196f3" : props.$isDragReject ? "#ff1744" : "#ccc"};
  background-color: ${(props) =>
    props.$isDragAccept ? "#e0f7fa" : props.$isDragReject ? "#ffebee" : "transparent"};
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: border 0.3s ease, background-color 0.3s ease;
`;

export const Thumb = styled.div`
  position: relative;
  display: inline-flex;
  border-radius: 2px;
  border: 1px solid #eaeaea;
  margin-bottom: 8px;
  margin-right: 8px;
  width: 100px;
  height: 100px;
  padding: 4px;
  box-sizing: border-box;
`;

export const ThumbInner = styled.div`
  display: flex;
  min-width: 0;
  overflow: hidden;
`;

export const StyledImg = styled.img`
  display: block;
  width: auto;
  height: 100%;
`;

export const StyledParagraph = styled.p`
  margin: 0;
  color: #666;
`;

export const ThumbsContainer = styled.aside`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 16px;
`;

export const DeleteIcon = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
`;